<app-table
  *ngIf="products && showTable"
  [lazy]="false"
  [cols]="productCols"
  [elements]="products"
  sortField="shippingOrderId"
  [sortOrder]="-1"
  [addButton]="false"
  modelName="produtos"
  tableTitle="Reenvios aguardando estoque"
  [changeColumns]="true"
  [actionButtons]="actionButtons"
  selectionActionLabel="Substituir {{ selectionSize }} itens"
  selectionActionIcon="pi pi-arrow-right-arrow-left"
  selectionActionTooltip="Selecionar produto para substituir os itens"
  selectionActionClass="p-button-highlight"
  (emitSelection)="productSelectionModal($event)"
  [defaultRows]="10"
  [extraButton]="permission"
  (extraButtonClick)="recalculateStocks()"
  extraLabel="Atualizar estoques"
  extraButtonTooltip="Verifica o estoque de pedidos AG. ESTOQUE"
  extraButtonTooltipPosition="bottom"
/>
<p-toast />
<p-dialog
  [(visible)]="reviewModalVisible"
  header="Substituição de produtos"
  [modal]="true"
  [draggable]="false"
  (onHide)="modalClose()"
>
  <div class="product-substitution-modal">
    <div class="product-substitution-modal__product">
      <div class="product-image">
        <img
          [src]="
            product?.defaultImageURL || 'assets/images/no_img_available.jpg'
          "
        />
      </div>
      <div class="product-substitution-modal__product__info">
        <h4>
          <a
            [routerLink]="
              '/products/catalog/product-variant/' + product?.productVariantId
            "
            class="data-link"
          >
            {{ product?.productVariantName }}
          </a>
        </h4>
      </div>
    </div>
    <div class="product-substitution-modal__products">
      <h3>Produtos a serem substituídos</h3>
      <app-table
        [cols]="substitutionCols"
        *ngIf="productsGrouped"
        [lazy]="false"
        [elements]="productsGrouped"
        [showHeader]="false"
        modelName="produtos"
      />
    </div>
    <div class="product-substitution-modal__actions">
      <p-button
        label="Escolher outro produto"
        styleClass="p-button-danger"
        (onClick)="chooseOtherProduct()"
      />
      <p-button label="Confirmar" (onClick)="updateShippingOrderItems()" />
    </div>
  </div>
</p-dialog>
